/*
  Yalla Mahjong: wish landing page.

  Reads the wish details from the page address and fills in the page.
  Everything here treats those details as untrusted, because anyone can
  craft the link: text is written with textContent, never as HTML, and
  the product link and image are only used if they point at this store,
  so the page cannot be turned into a way to send someone elsewhere.
*/

(function () {
  'use strict';

  var root = document.querySelector('[data-wish-landing]');
  if (!root) return;

  var params = new URLSearchParams(window.location.search);

  function get(name) {
    var v = params.get(name);
    return v ? v.trim() : '';
  }

  // Hosts we are willing to link or load an image from.
  function hostAllowed(hostname) {
    return (
      hostname === window.location.hostname ||
      hostname === 'yallamahjong.com' ||
      /(^|\.)yallamahjong\.com$/.test(hostname) ||
      /(^|\.)myshopify\.com$/.test(hostname) ||
      /(^|\.)shopify\.com$/.test(hostname)
    );
  }

  function safeUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      if (!hostAllowed(url.hostname)) return '';
      return url.href;
    } catch (e) {
      return '';
    }
  }

  function show(el) { if (el) el.hidden = false; }

  var wisher = get('wisher');
  var productName = get('product');
  var note = get('note');
  var productUrl = safeUrl(get('product_url'));
  var imageUrl = safeUrl(get('image'));

  var bodyEl = root.querySelector('[data-wish-body]');
  var emptyEl = root.querySelector('[data-wish-empty]');

  // A wish needs at least someone and something.
  if (!wisher && !productName) {
    show(emptyEl);
    return;
  }

  show(bodyEl);

  var wisherEl = root.querySelector('[data-wish-wisher]');
  if (wisherEl && wisher) wisherEl.textContent = wisher;

  var productEl = root.querySelector('[data-wish-product]');
  if (productEl && productName) {
    productEl.textContent = productName;
    show(productEl);
  }

  var noteEl = root.querySelector('[data-wish-note]');
  if (noteEl && note) {
    noteEl.textContent = note;
    show(noteEl);
  }

  var mediaEl = root.querySelector('[data-wish-media]');
  var imageEl = root.querySelector('[data-wish-image]');
  if (mediaEl && imageEl && imageUrl) {
    imageEl.src = imageUrl;
    if (productName) imageEl.alt = productName;
    show(mediaEl);
  }

  var ctaEl = root.querySelector('[data-wish-cta]');
  if (ctaEl && productUrl) {
    ctaEl.href = productUrl;
    show(ctaEl);
  } else if (ctaEl) {
    // No safe product link: leave the button hidden rather than dead.
    ctaEl.hidden = true;
  }
})();
